import React from 'react';

function About() {
  return (
    <>
      <section className="page-hero">
        <div className="container">
          <h1>Hakkımızda</h1>
          <p>EMUR INNOVATION olarak teknoloji ve inovasyonu işletmenizin hizmetine sunuyoruz.</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="content-grid">
            <div>
              <div className="section-label" style={{ justifyContent: 'flex-start' }}>Biz Kimiz?</div>
              <h2 style={{ fontSize: '2rem', fontWeight: 800, marginBottom: '20px' }}>
                Yeni Nesil Bulut Entegratörü
              </h2>
              <p style={{ color: 'var(--text-secondary)', lineHeight: 1.8, marginBottom: '16px' }}>
                EMUR INNOVATION, ürettiği stratejik ve sektörel BT çözümleri ile yeni nesil bir teknoloji 
                firmasıdır. Rekabetçi maliyet ve bağımsız marka hizmet anlayışıyla, veri merkezi işletmeciliği, 
                erişim servisleri, cloud ve sunucu alanında katma değerli servisler sunmak amacıyla kurulmuştur.
              </p>
              <p style={{ color: 'var(--text-secondary)', lineHeight: 1.8, marginBottom: '16px' }}>
                Genç, uzman ve yenilikçi ekibimizle birlikte üst düzey teknolojiyi iş dünyasının hizmetine 
                sunuyoruz. 8 farklı ülkede 15 farklı teknoloji lokasyonuyla global ölçekte hizmet veriyoruz.
              </p>
              <div className="feature-list">
                <div className="feature-item">
                  <div className="feature-check">✓</div>
                  <div>
                    <strong>ISO 27001 Sertifikalı</strong>
                    <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Bilgi güvenliği yönetim sistemi sertifikası</p>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-check">✓</div>
                  <div>
                    <strong>%99.9 Uptime SLA</strong>
                    <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Garantili hizmet seviyesi anlaşması</p>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-check">✓</div>
                  <div>
                    <strong>7/24 Teknik Destek</strong>
                    <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Kesintisiz teknik destek hizmeti</p>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-check">✓</div>
                  <div>
                    <strong>KVKK Uyumlu</strong>
                    <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Kişisel verilerin korunması kanununa tam uyum</p>
                  </div>
                </div>
              </div>
            </div>
            <div style={{
              background: 'var(--gradient-card)',
              border: '1px solid var(--border-subtle)',
              borderRadius: 'var(--radius-xl)',
              padding: '48px',
              display: 'flex',
              flexDirection: 'column',
              gap: '24px'
            }}>
              <div style={{ fontSize: '3rem', textAlign: 'center' }}>🏢</div>
              <h3 style={{ textAlign: 'center', fontSize: '1.3rem' }}>Vizyonumuz</h3>
              <p style={{ color: 'var(--text-secondary)', textAlign: 'center', lineHeight: 1.8 }}>
                Türkiye'nin ve bölgenin en güvenilir bulut teknoloji ortağı olmak. 
                İşletmelerin dijital dönüşüm süreçlerinde yanlarında olarak, 
                teknolojiyi erişilebilir ve sürdürülebilir kılmak.
              </p>
              <h3 style={{ textAlign: 'center', fontSize: '1.3rem', marginTop: '16px' }}>Misyonumuz</h3>
              <p style={{ color: 'var(--text-secondary)', textAlign: 'center', lineHeight: 1.8 }}>
                En yeni teknolojileri hayatın ve iş dünyasının merkezine entegre ederek, 
                müşterilerimize hızlı geri dönüş sağlayan, ölçülebilir ve sürdürülebilir 
                çözümler sunmak.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default About;
